import { render } from "./TrainingVideoEmbed.vue?vue&type=template&id=7221ce31&scoped=true"
import script from "./TrainingVideoEmbed.vue?vue&type=script&lang=js"
export * from "./TrainingVideoEmbed.vue?vue&type=script&lang=js"

import "./TrainingVideoEmbed.vue?vue&type=style&index=0&id=7221ce31&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7221ce31"]])

export default __exports__